module.exports = __webpack_public_path__ + "static/media/oldGrowth.7f313ff9.svg";